import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import Router from 'next/router';

import { Icon, Skeleton } from 'antd';
import { useQuery, useMutation } from '@apollo/react-hooks';
import * as CartQueries from './queries';
import * as AuthQueries from '../auth/queries';

import Layout from '../../components/Layout';
import NoItemSVG from '../../assets/svg/noItem';
import { CartRealClickTrackingScript } from '../../lib/addRealClickScript';

const Cart = () => {
  const [deleteCartLine] = useMutation(CartQueries.DELETE_CART_LINE, {
    refetchQueries: [{ query: CartQueries.USER_CARTS }]
  });
  const [updateAmount] = useMutation(CartQueries.UPDATE_AMOUNT, {
    refetchQueries: [{ query: CartQueries.USER_CARTS }]
  });
  const {
    data: {
      auth: { isLoggedIn }
    }
  } = useQuery(AuthQueries.AUTH);
  const { loading, data: userCartsData, refetch } = useQuery(CartQueries.USER_CARTS, {
    skip: !isLoggedIn,
    fetchPolicy: 'cache-and-network'
  });
  const handleDelete = id => {
    deleteCartLine({
      variables: {
        cartLineId: id
      }
    });
  };
  useEffect(() => {
    refetch();
  }, []);
  const userCarts = _.get(userCartsData, 'userCarts');
  const cartLines = _.get(userCarts, 'cartLines');
  const sortedCartLines = _(cartLines)
    .orderBy('created', 'desc')
    .value();
  const cartLinesExist = !_.isEmpty(cartLines);
  const cartsTotalPrice = _.sumBy(cartLines, function(params) {
    const { amount } = params;
    return params.productVariant.discountedPrice * amount;
  });
  const handleProductPage = (id, code) => {
    Router.push({
      pathname: `/eatmarket/${code}`,
      query: { productId: id }
    }).then(() => {
      window.scrollTo(0, 0);
    });
  };
  const handleBack = () => {
    Router.push({
      pathname: '/eatmarket'
    }).then(() => {
      window.scrollTo(0, 0);
    });
  };

  const handleCheckout = () => {
    let isThanksGiving = false;
    for (let item of cartLines) {
      if (item.productVariant.product.id === '13') {
        isThanksGiving = true;
      }
    }
    if (cartLines.length > 1 && isThanksGiving) {
      alert('추석선물세트만 장바구니에 담아주세요.');
    } else {
      Router.push({
        pathname: '/checkout'
      }).then(() => {
        window.scrollTo(0, 0);
      });
    }
  };
  // # deliveryFee
  const [deliveryFee, setDeliveryFee] = useState(3500);

  useEffect(() => {
    if (!cartLines || cartLines.length === 0) return () => {
    };
    const productIdList = cartLines?.map(item => item?.productVariant?.product?.id);
    const script = CartRealClickTrackingScript({ realItem: productIdList.join(',') });
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [cartLines]);

  useEffect(() => {
    // 비투석덮밥 무료배송 이벤트

    const isDeliverfyFreeProductVariant = Array.isArray(cartLines) && cartLines?.filter(cartLine => cartLine?.productVariant?.id === '204');

    const isDeliverfyFreeProduct =
      Array.isArray(cartLines) &&
      cartLines?.filter(
        cartLine => cartLine?.productVariant?.id === '207' || cartLine?.productVariant?.id !== '208' || cartLine?.productVariant?.id !== '213' || cartLine?.productVariant?.id !== '214'
      );

    const isNotDeliverfyFreeProduct =
      Array.isArray(cartLines) &&
      cartLines?.filter(
        cartLine =>
          cartLine?.productVariant?.id !== '204' &&
          cartLine?.productVariant?.id !== '207' &&
          cartLine?.productVariant?.id !== '208' &&
          cartLine?.productVariant?.id !== '213' &&
          cartLine?.productVariant?.id !== '214'
      );

    // 204번 상품옵션만 있는경우
    // 204번이 있는경우와 [207,208,213,214] 옵션 중 한개만 있는경우가 아니고 타 상품이 없는 경우
    if (isDeliverfyFreeProduct?.length > 0 && isDeliverfyFreeProductVariant?.length > 0 && cartLines?.length >= 2 && isNotDeliverfyFreeProduct?.length === 0) {
      setDeliveryFee(0);
    } else {
      setDeliveryFee(3500);
    }

    if (isDeliverfyFreeProductVariant?.length > 0 && cartLines?.length > 0 && isNotDeliverfyFreeProduct?.length === 0) {
      setDeliveryFee(0);
    } else {
      setDeliveryFee(3500);
    }
    if (cartsTotalPrice >= 40000) {
      setDeliveryFee(0);
    }
  }, [cartsTotalPrice]);
  const handleChangeQuantity = (id, name, amount) => {
    const decrease = name === 'decrease';
    if (amount === 1 && decrease) {
      window.alert('최소수량은 1개 이상입니다.');
      return;
    }
    const increase = name === 'increase';
    updateAmount({
      variables: {
        isIncrease: !!increase,
        cartLineId: id
      }
    });
  };
  if (loading) {
    return <Skeleton active />;
  }
  let totalProduct = cartLines?.map(item => {
    return item?.productVariant?.product?.code;
  });
  //   const isTemp = Array.isArray(cartLines) && cartLines[0]?.productVariant?.product?.id == '43';

  return (
    <Layout store>
      <Title>장바구니</Title>
      {cartLinesExist ? (
        <AddItemContainer>
          {sortedCartLines &&
            sortedCartLines.map(variant => {
              const { id, amount, productVariant } = variant || {};
              const { discountedPrice, longName, name, price, product } = productVariant || {};
              const defaultImage = _.get(product, 'images.0.image');
              return (
                <Item>
                  <Div>
                    <Div>
                      <Image onClick={() => handleProductPage(product.id, product.code)}>
                        <img src={defaultImage} alt="기본이미지" />
                      </Image>
                      <Info>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: '#bcbcbc'
                          }}
                        >
                          <Brand>맛있저염</Brand>
                          <Icon type="close" style={{ fontSize: '1.6rem' }} onClick={() => handleDelete(id)} />
                        </div>
                        <ItemTitle
                          onClick={() => handleProductPage(product.id, product.code)}>{product.name}</ItemTitle>
                        <SelectedOption>{name}</SelectedOption>
                      </Info>
                    </Div>
                  </Div>
                  <Div>
                    <Amount>
                      <Div>
                        <Minus type="button" name="decrease" aria-label="수량 1개 제거"
                               onClick={() => handleChangeQuantity(id, 'decrease', amount)}>
                          <Icon type="minus" style={{ color: '#00129a', fontSize: '1.4rem' }} />
                        </Minus>
                        <Quantity>{amount}</Quantity>
                        <Plus type="button" name="increase" aria-label="수량 1개 추가"
                              onClick={() => handleChangeQuantity(id, 'increase')}>
                          <Icon type="plus" style={{ color: '#00129a', fontSize: '1.4rem' }} />
                        </Plus>
                      </Div>
                      <Price>
                        <span>{(price * amount).toLocaleString()}원</span>
                        {(discountedPrice * amount).toLocaleString()}원
                      </Price>
                    </Amount>
                  </Div>
                </Item>
              );
            })}
        </AddItemContainer>
      ) : (
        <NoItemContainer>
          <NoItemSVG />
          장바구니에 담긴 상품이 없습니다.
        </NoItemContainer>
      )}
      <CheckoutContainer>
        <Label>
          <label>총 상품 가격</label>
          <span>{cartsTotalPrice.toLocaleString()} 원</span>
        </Label>
        <Label>
          <label>배송비</label>
          <span>
            {deliveryFee.toLocaleString()} 원 <br />
            <span style={{ fontSize: '1.3rem', color: '#00129a' }}> 40,000원 이상 주문 시, 무료배송</span>
          </span>
        </Label>
        <TotalPrice>
          <label>결제 예정금액</label>
          <span>{(cartsTotalPrice + deliveryFee).toLocaleString()} 원</span>
        </TotalPrice>
      </CheckoutContainer>
      <ButtonGroup>
        {/* TODO 리스트가 없을 때 */}
        <Button onClick={handleBack}>쇼핑 계속하기</Button>
        {cartLinesExist ? (
          <Button checkout onClick={handleCheckout}>
            주문하기
          </Button>
        ) : (
          <NoItem>주문하기</NoItem>
        )}
      </ButtonGroup>
    </Layout>
  );
};

const Title = styled.h1`
    font-size: 1.4rem;
    background-color: #f7f7f7;
    height: 40px;
    font-weight: 800;
    text-align: center;
    line-height: 40px;
    margin: 0;
`;
const AddItemContainer = styled.div`
    padding: 0 1.6rem;

    ${props => props.theme.device.md} {
        width: 772px;
        margin: 0 auto;
        padding: 0;
    }
`;
const Item = styled.div`
    padding: 2.4rem 0;
    border-bottom: 1px solid #ddd;
    width: 100%;

    ${props => props.theme.device.md} {
        width: 772px;
        margin: 0 auto;
    }
`;
const Div = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;
const Image = styled.div`
    margin-right: 1.6rem;
    width: 90px;
    height: 90px;
    overflow: hidden;
    cursor: pointer;

    img {
        width: 100%;
        height: auto;
    }
`;
const Info = styled.div`
    width: 100%;
`;
const Brand = styled.h2`
    color: #00129a;
    font-size: 1.2rem;
    font-weight: 700;
`;
const ItemTitle = styled.h2`
    display: block;
    width: 100%;
    word-break: keep-all;
    line-height: 1.4em;
    color: #3c3c3c;
    font-size: 1.4rem;
    font-weight: 700;
    cursor: pointer;
`;
const SelectedOption = styled.div`
    width: 100%;
    text-align: justify;
    color: #bcbcbc;
    font-size: 1.2rem;
    font-weight: 700;
`;
const Amount = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    /* padding: 0.8rem 0 0 4rem; */
`;
const Minus = styled.button`
    cursor: pointer;
    width: 2.4rem;
    height: 2.4rem;
    border: 1px solid #b2b2b2;
    background-color: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const Plus = styled(Minus)``;
const Quantity = styled.span`
    width: 32px;
    height: 24px;
    font-size: 1.2rem;
    line-height: 24px;
    text-align: center;
    border-top: 1px solid #b2b2b2;
    border-bottom: 1px solid #b2b2b2;
`;
const Price = styled.span`
    font-size: 1.4rem;
    font-weight: 800;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    width: 100%;

    span {
        text-decoration: line-through;
        color: #bdbdbd;
        margin-right: 0.5rem;
        font-weight: 600;
    }
`;
const NoItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4.2rem 0;
    font-size: 1.2rem;
    font-weight: 800;
    color: #b2b2b2;

    ${props => props.theme.device.md} {
        width: 772px;
        margin: 0 auto;
    }
`;
const CheckoutContainer = styled.div`
    margin-top: 1rem;
    background-color: #f7f7f7;
    border: 1px solid #ddd;
    padding: 2.4rem 1.6rem;

    ${props => props.theme.device.md} {
        width: 772px;
        margin: 2rem auto;
    }
`;
const Label = styled.div`
    font-size: 1.4rem;
    display: flex;
    margin-bottom: 1.6rem;

    label {
        color: #b2b2b2;
        font-weight: 800;
        flex: 1;
    }

    span {
        color: #3c3c3c;
        font-weight: 800;
        text-align: right;
        flex: 2;
    }
`;
const TotalPrice = styled(Label)`
    border-top: 1px solid #ddd;
    padding-top: 2rem;
    margin-top: 2rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 0;

    label {
        color: #3c3c3c;
        font-size: 1.4rem;
    }

    span {
        font-weight: 800;
        font-size: 2rem;
        color: #00129a;
    }
`;
const ButtonGroup = styled.div`
    width: 100%;
    display: flex;
    padding: 0 1.6rem;
    margin: 1.6rem 0;

    ${props => props.theme.device.md} {
        width: 772px;
        margin: 2rem auto;
        padding: 0;
    }
`;
const Button = styled.button`
    padding: 0;
    flex: 1;
    height: 4.8rem;
    font-size: 1.4rem;
    font-weight: 700;
    color: ${props => (props.checkout ? '#fff' : '#bcbcbc')};
    background-color: ${props => (props.checkout ? '#ff7e1f' : '#f7f7f7')};
    border: ${props => (props.checkout ? 'none' : '1px solid #bcbcbc')};
    cursor: pointer;
`;
const NoItem = styled(Button)`
    background-color: #bcbcbc;
    color: #fff;
`;
export default Cart;
